/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {

  function initHeaderColorControl() {
    const slideshow = document.querySelector('[data-section-type="slideshow"]');
    const header = document.querySelector('[data-header-wrapper]');

    if (!slideshow || !header) return;

    function setDark() {
      header.style.setProperty('--link', '#000000');
      header.style.setProperty('--link-hover', '#000000');
      header.style.setProperty('--COLOR-MENU-TRANSPARENT', '#000000');
      header.querySelectorAll('.logo__img--transparent, .logo__img--color').forEach(el => el.style.filter = 'invert(1)');
      header.querySelectorAll('svg path, svg circle, svg line, svg polyline').forEach(el => el.style.stroke = '#000000');
      header.querySelectorAll('.navlink, .navtext').forEach(el => el.style.color = '#000000');
    }

    function setLight() {
      header.style.removeProperty('--link');
      header.style.removeProperty('--link-hover');
      header.style.removeProperty('--COLOR-MENU-TRANSPARENT');
      header.querySelectorAll('.logo__img--transparent, .logo__img--color').forEach(el => el.style.filter = '');
      header.querySelectorAll('svg path, svg circle, svg line, svg polyline').forEach(el => el.style.stroke = '');
      header.querySelectorAll('.navlink, .navtext').forEach(el => el.style.color = '');
    }

    function updateHeaderColor() {
      const activeSlide = slideshow.querySelector('.slideshow__slide.is-selected');
      if (!activeSlide) return;
      const color = activeSlide.dataset.headerColor || 'light';
      header.setAttribute('data-header-color', color);
      color === 'dark' ? setDark() : setLight();
    }

    setTimeout(updateHeaderColor, 800);

    // Use MutationObserver to watch for class changes on slides
    const observer = new MutationObserver(updateHeaderColor);
    slideshow.querySelectorAll('.slideshow__slide').forEach(slide => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  document.addEventListener('DOMContentLoaded', initHeaderColorControl);
  window.addEventListener('load', initHeaderColorControl);

})();
window.mwChangeSubscriptionFrequency = function (selectEl) {
  var previousPlanId = null;
  Array.prototype.forEach.call(selectEl.options, function (opt) {
    if (opt.defaultSelected) previousPlanId = opt.value;
  });

  var newPlanId = selectEl.value;
  var lineKey = selectEl.dataset.lineKey;
  var variantId = parseInt(selectEl.dataset.variantId, 10);
  var quantity = parseInt(selectEl.dataset.quantity, 10) || 1;
  var cartItems = document.querySelector('cart-items');

  selectEl.disabled = true;
  if (cartItems) cartItems.classList.add('is-loading');

  function refreshCart() {
    if (cartItems && typeof cartItems.getCart === 'function') {
      cartItems.getCart();
    } else {
      window.location.reload();
    }
  }

  function showError(message) {
    selectEl.disabled = false;
    if (cartItems) cartItems.classList.remove('is-loading');
    alert(message || "Sorry, we couldn't update your delivery frequency. Please try again.");
  }

  // Remove the old frequency's line FIRST. With limited stock, trying to
  // add the new line while the old one still holds inventory can fail
  // with "maximum quantity already in cart" — freeing the slot first
  // avoids that.
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity, selling_plan: parseInt(newPlanId, 10) }]
        })
      });
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      refreshCart();
    })
    .catch(function (err) {
      console.error('Frequency change failed, attempting to restore original:', err);
      // The old line is gone and the new one failed — try to put the
      // customer's original frequency back so they don't lose the item.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity, selling_plan: parseInt(previousPlanId, 10) }]
        })
      })
        .then(function () {
          refreshCart();
          showError((err && err.description) || "Sorry, we couldn't switch to that frequency. Your original delivery schedule has been kept.");
        })
        .catch(function () {
          refreshCart();
          showError("Sorry, something went wrong updating your subscription. Please check your cart before checking out.");
        });
    });
};